import { type FC } from 'react';
import { Center, Loader } from '@mantine/core';

export const AppLoader: FC = () => {
    return (
        <Center h='100vh'>
            <Loader
                color='currentColor'
                size='lg'
            />
        </Center>
    );
};
